/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateFolderCommandRequest } from '../models/CreateFolderCommandRequest';
import type { CreateFolderCommandResponse } from '../models/CreateFolderCommandResponse';
import type { GetSharePointFoldersFromSiteCommandRequest } from '../models/GetSharePointFoldersFromSiteCommandRequest';
import type { GetSharePointFoldersFromSiteCommandResponse } from '../models/GetSharePointFoldersFromSiteCommandResponse';
import type { GetSharePointSitesCommandRequest } from '../models/GetSharePointSitesCommandRequest';
import type { GetSharePointSitesCommandResponse } from '../models/GetSharePointSitesCommandResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { GetSharePointChildrenFoldersCommandRequest } from '../models/GetSharePointFolderChildrenCommandRequest';
import { GetSharePointChildrenFoldersCommandResponse } from '../models/GetSharePointFolderChildrenCommandResponse';
import { GetSharePointChildrenFoldersStreamCommandResponse } from '../models/GetSharePointFolderChildrenStreamCommandResponse';
import { GetSharePointChildrenFoldersStreamCommandRequest } from '../models/GetSharePointFolderChildrenStreamCommandRequest';
import { SearchFolderCommandRequest } from '../models/SearchFolderCommandRequest';
import { SearchFolderCommandResponse } from '../models/SearchFolderCommandResponse';
@Injectable({
    providedIn: 'root',
})
export class SharePointApiService {
    constructor(public readonly http: HttpClient) { }
    /**
     * @param query
     * @returns GetSharePointSitesCommandResponse OK
     * @throws ApiError
     */
    public getApiV10SharePointGetSites(
        query?: GetSharePointSitesCommandRequest,
    ): Observable<GetSharePointSitesCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/SharePoint/GetSites',
            query: {
                'query': query,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns GetSharePointFoldersFromSiteCommandResponse OK
     * @throws ApiError
     */
    public postApiV10SharePointGetFolders(
        requestBody?: GetSharePointFoldersFromSiteCommandRequest,
    ): Observable<GetSharePointFoldersFromSiteCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/SharePoint/GetFolders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

        /**
     * @param requestBody
     * @returns GetSharePointFoldersFromSiteCommandResponse Success
     * @throws ApiError
     */
        public postApiV10SharePointGetChildrenFolder(
            requestBody?: GetSharePointChildrenFoldersCommandRequest,
        ): Observable<GetSharePointChildrenFoldersCommandResponse> {
            return __request(OpenAPI, this.http, {
                method: 'POST',
                url: '/api/v1.0/SharePoint/GetChildrenFolders',
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    404: `Not Found`,
                },
            });
        }


        /**
     * @param requestBody
     * @returns GetSharePointChildrenFoldersStreamCommandResponse Success
     * @throws ApiError
     */
        public postApiV10SharePointGetChildrenFolderStream(
            requestBody?: GetSharePointChildrenFoldersStreamCommandRequest,
        ): Observable<GetSharePointChildrenFoldersStreamCommandResponse> {
            return __request(OpenAPI, this.http, {
                method: 'POST',
                url: '/api/v1.0/SharePoint/GetChildrenFoldersStream',
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    404: `Not Found`,
                },
            });
        }
    

    /**
     * @param requestBody
     * @returns CreateFolderCommandResponse OK
     * @throws ApiError
     */
    public postApiV10SharePointCreateFolder(
        requestBody?: CreateFolderCommandRequest,
    ): Observable<CreateFolderCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/SharePoint/CreateFolder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }


    /**
     * @param requestBody
     * @returns SearchFolderCommandResponse OK
     * @throws ApiError
     */
    public postApiV10SharePointSearchFolder(
        requestBody?: SearchFolderCommandRequest,
    ): Observable<SearchFolderCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/SharePoint/SearchFolder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
